import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Button } from '@sendgrid/ui-components/button';
import { TextInput } from '@sendgrid/ui-components/text-input';
import { COOKIES } from '../constants';
import withAccountInputs from '../containers/withAccountInputsV1';
import ConnectedCaptcha from './Captcha';
import ConnectedToSInfo from './ToSInfo';
import withPackages from '../containers/withPackages';
import accountTypes from '../constants/accountTypes';
import AdsPackage from '../utils/adsPackage';
import { removeCookie, getParsedCookie } from '../utils/cookieHelpers';
import validationRules from '../constants/validationRules';

export class AccountInputsV1 extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    // if it's an ads user, we initialize the activePackage with the AdsPackage
    // and delete the sign up cookie from the website (edge case)
    if (this.props.accountType.toLowerCase() === accountTypes.ads) {
      this.props.setPackage([new AdsPackage()]);
      removeCookie(COOKIES.SELECTED_PACKAGES);
    }
    const signUpVals = getParsedCookie(COOKIES.SELECTED_PACKAGES);
    if (signUpVals && signUpVals.email && signUpVals.email.length) {
      this.props.setEmail(undefined, signUpVals.email);
    }
  }

  submit() {
    const postBody = {
      username: this.props.formInputs.username_value,
      password: this.props.formInputs.password_value,
      email: this.props.formInputs.email_value,
      recaptcha_token: this.props.formInputs.recaptcha_token
    };

    this.props.createUser(
      postBody,
      this.props.packages.activePackage,
      this.props.packages.activeIsFree,
      this.props.history
    );
  }

  render() {
    return (
      <section className="form-container" data-role="account-inputs-container">
        <TextInput
          type="text"
          label="Username"
          isRequired
          isValid={
            this.props.formInputs.username_isValid &&
            this.props.formInputs.username_unique_isValid
          }
          id="username"
          info={
            this.props.formInputs.username_errorType === ''
              ? this.props.formInputs.username_unique_errorType
              : this.props.formInputs.username_errorType
          }
          onChange={this.props.setUsername}
          onBlur={this.props.usernameExistsCheck}
          value={this.props.formInputs.username_value}
          data-role="username-field"
        />

        <TextInput
          type="password"
          label="Password"
          isRequired
          isValid={this.props.formInputs.password_isValid}
          id="password"
          info={
            this.props.formInputs.password_errorType ||
            `Must have at least ${validationRules.PASSWORD_LENGTH_MIN} characters, including at least 1 letter and number.`
          }
          onChange={this.props.setPassword}
          onBlur={this.props.blurPassword}
          value={this.props.formInputs.password_value}
          data-role="password-field"
        />

        <TextInput
          type="password"
          label="Confirm Password"
          isRequired
          isValid={this.props.formInputs.confirmPassword_isValid}
          info={this.props.formInputs.confirmPassword_errorType}
          id="password-confirm"
          onChange={this.props.setConfirmPassword}
          onBlur={this.props.blurConfirmPassword}
          value={this.props.formInputs.confirmPassword_value}
          data-role="confirm-password-field"
        />

        <TextInput
          type="email"
          label="Email Address"
          isRequired
          isValid={this.props.formInputs.email_isValid}
          id="email"
          info={this.props.formInputs.email_errorType}
          data-role="email-field"
          onChange={this.props.setEmail}
          onBlur={this.props.blurEmail}
          value={this.props.formInputs.email_value}
        />
        <ConnectedCaptcha />
        <center>
          <ConnectedToSInfo
            isAds={this.props.accountType.toLowerCase() === accountTypes.ads}
          />
          {this.props.packages && this.props.packages.activePackage && (
            <Button
              type="primary"
              onClick={this.submit}
              data-role="create-account-button"
              disabled={
                !(
                  this.props.formInputs.form_isValid &&
                  this.props.formInputs.captcha_isValid
                )
              }
              loading={false}
            >
              {this.props.packages.activeIsFree ? 'Create Account' : 'Continue'}
            </Button>
          )}
        </center>
      </section>
    );
  }
}

AccountInputsV1.propTypes = {
  formInputs: PropTypes.shape({
    username_isValid: PropTypes.bool.isRequired,
    username_value: PropTypes.string.isRequired,
    username_errorType: PropTypes.string.isRequired,
    username_unique_isValid: PropTypes.bool.isRequired,
    username_unique_value: PropTypes.string.isRequired,
    username_unique_errorType: PropTypes.string.isRequired,
    password_isValid: PropTypes.bool.isRequired,
    password_errorType: PropTypes.string.isRequired,
    password_value: PropTypes.string.isRequired,
    confirmPassword_isValid: PropTypes.bool,
    confirmPassword_errorType: PropTypes.string.isRequired,
    confirmPassword_value: PropTypes.string.isRequired,
    email_isValid: PropTypes.bool,
    email_value: PropTypes.string.isRequired,
    email_errorType: PropTypes.string.isRequired,
    form_isValid: PropTypes.bool,
    captcha_isValid: PropTypes.bool,
    recaptcha_token: PropTypes.string
  }).isRequired,
  setUsername: PropTypes.func.isRequired,
  setPassword: PropTypes.func.isRequired,
  setConfirmPassword: PropTypes.func.isRequired,
  setEmail: PropTypes.func.isRequired,
  blurPassword: PropTypes.func.isRequired,
  blurConfirmPassword: PropTypes.func.isRequired,
  blurEmail: PropTypes.func.isRequired,
  usernameExistsCheck: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  packages: PropTypes.shape({
    activePackage: PropTypes.array.isRequired,
    activeIsFree: PropTypes.bool.isRequired
  }).isRequired,
  createUser: PropTypes.func.isRequired,
  accountType: PropTypes.string,
  setPackage: PropTypes.func.isRequired
};

AccountInputsV1.defaultProps = {
  accountType: accountTypes.email
};

const ConnectedAccountInputs = withRouter(
  withAccountInputs(withPackages(AccountInputsV1))
);
export default ConnectedAccountInputs;
